<div class="summary-panel container-component container-fluid" [ngStyle]="getSummaryPanelHeight()">
    <div class="row col-xs-12 no-gutter summary-table">
      <div *ngFor="let storyPoint of storyPointList" class="row card summary-slot">

        <div class="row summary-title-row">
          <span class="summary-selection-icon" [ngClass]="getSelectionSummaryIcon(storyPoint)"></span><div class="summary-cover-title">
            {{storyPoint.storyFullTitle}}</div>
        </div>

        <div class="row summary-steps-row">
          <img src="{{getCoverImage(storyPoint)}}" class="no-gutter summary-cover-image" />
          <div class="col-xs-7 summary-block">
              <div class="row summary-total-row">
                  <div>Total Points Earned: </div>
                  <div class="total-points">{{getTotalAttemptedPoints(storyPoint)}}/{{getTotalPossiblePoints(storyPoint)}}</div>
              </div>
             
              <div class="row summary-step-row">
                <span class="summary-step-icon" [ngClass]="getStepThreeStatusIcon(storyPoint)"></span>
                <div class="step-label">Step 3: Quiz</div>
                <div class="quiz-points-style">{{storyPoint.quizHighestPoint}}/{{storyPoint.targetQuizTotalPoint}}</div>
              </div>

              <div class="row summary-step-row">
                 <span class="summary-step-icon" [ngClass]="getStepTwoStatusIcon(storyPoint)"></span>
                  <div class="step-label">Step 2: Read & Record </div>
                  <div class="read-points-style">{{storyPoint.recordHighestPoint}}/{{storyPoint.targetRecordTotalPoint}}</div>
              </div>

              <div class="row summary-step-row">
                  <span class="summary-step-icon" [ngClass]="getStepOneStatusIcon(storyPoint)"></span>
                  <div class="step-label">Step 1: Preview & Read</div>
                  <div class="preview-points-style ">{{storyPoint.taqFirstPoint}}/{{storyPoint.targetTAQTotalPoint}}</div>
              </div>
          </div>
        </div>

        <div class="row summary-btns-row">
          <div class="report-row">
            View Reports
           <span class="arrow-mark"></span>
          </div>
          <div class="btn-group summary-btn-group" role="group">
          
            <label class="btn summary-btns"
                   (click)="openFluencyReport(storyPoint)"
                   [class.disabled]="!storyPoint.recordCount || storyPoint.recordCount === 0">
              <span class="icon icon-flu"></span>Fluency
            </label>
            <label class="btn summary-btns"
                   (click)="openSelectionReport(storyPoint)"
                   [class.disabled]="!storyPoint.storyCompleted">
              <span class="icon icon-sel"></span>Selection
            </label>
          </div>
        </div>

      </div>
    </div>
</div>
